import { render, staticRenderFns } from "./model-r1-optimize-recipients-dialog.vue?vue&type=template&id=a4828f5a&scoped=true&"
import script from "./model-r1-optimize-recipients-dialog.vue?vue&type=script&lang=js&"
export * from "./model-r1-optimize-recipients-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4828f5a",
  null
  
)

export default component.exports